import { apContacto } from './bff/bffClient';
import {
    mapCondicionIVA,
    mapCondicionIIBB,
    mapTipoDocumento,
    mapTipoPersona,
    mapProfesion,
    toNumber,
} from './bff/bffMappers';


export interface SolicitudCotizacionAP {
    compania?: string;

    // Datos Personales
    nombre: string;
    apellido: string;
    telefono: {
        CodigoArea: string;
        Numero: string;
    };
    email: string;
    localidad: string;
    provincia: string;
    departamento?: string;
    codigoPostal: string;

    // Datos Necesarios
    profesion: string;
    profesionDescripcion?: string;
    profesionDedicada?: string;

    condicionIVA: string;
    tipoPersona: string;
    condicionIB: string;
    condicionIIBB?: any;

    tipoDocumento: string;
    numeroDocumento: string;

    fechaInicio: string; // Formato de fecha: YYYY-MM-DD
    fechaFin: string;    // Formato de fecha: YYYY-MM-DD

    cantidad: number;
    sumaAsegurada?: number;
    sumaMuerte: number;
    sumaGastos: number;
    sumaInvalidez: number;
}

/**
 * Construye el DTO EXACTO que espera el BFF en POST /ap/contacto
 * (CotizacionAPDTO: telefono plano + codigoArea separado, profesion int,
 * enums como nombre de miembro C#, sumas number). Ver bffMappers.ts.
 */
export const buildCotizacionAPDTO = (params: SolicitudCotizacionAP) => {
    const sumaMuerte = toNumber(params.sumaMuerte);
    const sumaAsegurada =
        params.sumaAsegurada != null ? toNumber(params.sumaAsegurada) : sumaMuerte;

    return {
        Compania: params.compania ?? 'AP',
        Nombre: params.nombre ?? '',
        Apellido: params.apellido ?? '',
        // Telefono PLANO (solo número) + CodigoArea separado — el bind rompía cuando era objeto.
        Telefono: params.telefono?.Numero ?? '',
        CodigoArea: params.telefono?.CodigoArea ?? '',
        Email: params.email ?? '',
        Localidad: params.localidad ?? '',
        Provincia: params.provincia ?? '',
        Departamento: params.departamento ?? null,
        CodigoPostal: params.codigoPostal ?? '',
        Profesion: mapProfesion(params.profesion),
        SumaAsegurada: sumaAsegurada,
        CondicionIVA: mapCondicionIVA(params.condicionIVA),
        TipoPersona: mapTipoPersona(params.tipoPersona),
        CondicionIIBB: mapCondicionIIBB(params.condicionIIBB ?? params.condicionIB),
        TipoDocumento: mapTipoDocumento(params.tipoDocumento),
        NumeroDocumento: params.numeroDocumento ?? '',
        FechaInicio: params.fechaInicio ?? '',
        FechaFin: params.fechaFin ?? '',
        CantidadVidas: toNumber(params.cantidad),
        SumaMuerte: sumaMuerte,
        SumaGastos: toNumber(params.sumaGastos),
        SumaInvalidez: toNumber(params.sumaInvalidez),
        LandingUrl: typeof document !== 'undefined' ? document.location.href : undefined,
    };
};

/**
 * Paso 1 AP: guarda el contacto vía el BFF (POST {BFF}/ap/contacto).
 * El recaptcha lo mintea el bffClient y lo manda en el header `g-recaptcha-response`,
 * por eso `captchaToken` ya no se usa (se mantiene por compatibilidad de firma).
 * Adapta la respuesta del BFF ({ idContacto, token }) al envelope
 * { data: { api_status, api_data } } que consumen las páginas/componentes.
 */
export const guardarContactoAccidentesPersonales = async (
    params: SolicitudCotizacionAP,
    _captchaToken?: string
): Promise<any> => {
    const dto = buildCotizacionAPDTO(params);

    try {
        const apiData = await apContacto(dto);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
}
